<template>
    <LayoutSub>
        <SubSection class="pb-0">
            <div class="voc_container">
                <div class="left_area">
                    <h2>
                        KICC에 관심 가져주셔서 감사합니다.<br />
                        문의를 남겨주시면 빠른 시일 내에 연락드리겠습니다.
                    </h2>
                    <div class="infor">
                        <div class="row">
                            <span class="title">KICC ARS 이용안내 </span>
                            <span class="infor_content"><a href="tel:1600-1234">1600-1234</a></span>
                        </div>
                        <div class="row">
                            <span class="title">포스 고객센터 </span>
                            <span class="infor_content"><a href="tel:1599-9100">1599-9100</a></span>
                        </div>
                    </div>
                    <div class="button_wrap">
                        <RedLineButton text="상담챗봇" type="outbound" href="http://pf.kakao.com/_WxcxmPxj" />
                        <RedLineButton text="자주 하는 질문" type="inbound" to="/cs/faq" />
                    </div>
                </div>
                <div class="right_area">
                    <div class="area_title">
                        <h3>고객유형을 선택해주세요.</h3>
                        <span>
                            <span class="ess">*</span>
                            필수 선택 항목
                        </span>
                    </div>
                    <div class="tab_wrap">
                        <button
                            v-for="type of vocTypeData"
                            :key="type.tid"
                            type="button"
                            :class="+type.tid === +selectedVocType?.tid ? 'active' : ''"
                            @click="changeVocType(type)"
                        >
                            {{ type.name }}
                        </button>
                        <button type="button" @click="outerLink('https://www.easypay.co.kr/common/TradeCardAction.do', '_blank')">
                            이지페이결제고객
                            <i class="ico_outbound"></i>
                        </button>
                    </div>
                    <form>
                        <div class="row">
                            <div class="input_group">
                                <p>
                                    <span class="ess">*</span>
                                    사업자번호
                                </p>
                                <input
                                    type="text"
                                    name=""
                                    id=""
                                    placeholder="“-”없이 사업자번호를 입력해주세요."
                                    ref="bussno"
                                    @input="handleBussnoInput"
                                />
                            </div>
                            <div class="input_group">
                                <p>
                                    <span class="ess">*</span>
                                    가맹점명
                                </p>
                                <input type="text" name="" id="" ref="shopName" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="input_group">
                                <p>
                                    <span class="ess">*</span>
                                    고객명
                                </p>
                                <input type="text" name="" id="" style="width: calc(50% - 13px)" ref="name" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="input_group">
                                <p>
                                    <span class="ess">*</span>
                                    이메일
                                </p>
                                <div class="input_row">
                                    <input type="text" name="" id="" style="width: calc(50% - 13px)" ref="email1" />
                                    <span>@</span>
                                    <input
                                        type="text"
                                        name=""
                                        id=""
                                        style="width: calc(50% - 13px)"
                                        ref="email2"
                                        @change="this.$refs.emailSelect.value = ''"
                                    />
                                    <select
                                        @change="
                                            (e) => {
                                                this.$refs.email2.value = e.target.value;
                                            }
                                        "
                                        ref="emailSelect"
                                    >
                                        <option value="">직접입력</option>
                                        <option value="naver.com">naver.com</option>
                                        <option value="daum.net">daum.net</option>
                                        <option value="hanmail.net">hanmail.net</option>
                                        <option value="nate.com">nate.com</option>
                                        <option value="hotmail.com">hotmail.com</option>
                                        <option value="gmail.com">gmail.com</option>
                                        <option value="icloud.com">icloud.com</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="input_group">
                                <p>
                                    <span class="ess">*</span>
                                    휴대폰 번호
                                </p>
                                <div class="input_row">
                                    <input type="text" name="" id="" style="max-width: calc(50% - 13px)" ref="phone" />
                                    <label for="check01">
                                        <input type="checkbox" name="" id="check01" ref="smsYn" />
                                        <span class="check_box"></span>
                                        <span>SMS 수신 동의</span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="row title">
                            <h3>VOC 문의유형을 선택해주세요.</h3>
                        </div>

                        <div class="row" v-if="cateList.length !== 0">
                            <div class="tab_wrap" v-if="this.selectedVocType.tid === 3">
                                <button
                                    v-for="cate of cateList.filter((el) => el.new)"
                                    :key="cate.cid"
                                    type="button"
                                    :class="+selectedCate?.cid === +cate.cid ? 'active' : ''"
                                    @click="changeCate(cate)"
                                >
                                    {{ cate.name }}
                                </button>
                            </div>
                            <div class="tab_wrap" v-else>
                                <button
                                    v-for="cate of cateList"
                                    :key="cate.cid"
                                    type="button"
                                    :class="+selectedCate?.cid === +cate.cid ? 'active' : ''"
                                    @click="changeCate(cate)"
                                >
                                    {{ cate.name }}
                                </button>
                            </div>
                        </div>
                        <LoadingWrap v-else />

                        <template v-if="selectedCate">
                            <div class="row">
                                <div class="input_group">
                                    <p>
                                        <span class="ess">*</span>
                                        문의사항
                                    </p>

                                    <div class="radio_group">
                                        <label :for="`subCate_${subCate.cid}`" v-for="subCate of subCateList" :key="subCate.cid">
                                            <input
                                                type="radio"
                                                name="sub_cate"
                                                :id="`subCate_${subCate.cid}`"
                                                @change="(e) => selectedCid(e)"
                                                :value="subCate.cid"
                                            />
                                            <span class="radio_box"></span>
                                            <span>{{ subCate.name }}</span>
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div class="row border_row" v-if="selectedCate.agnInfoYn === 'Y' && agnInfor && this.errCode === '0000'">
                                <p class="border_row_title">관리대리점 안내</p>
                                <ul>
                                    <li>- 관리대리점 : {{ agnInfor?.agnNm || '' }}</li>
                                    <li>- 연락처 : {{ addHyphenToPhoneNumber(agnInfor?.phonNum) || '' }}</li>
                                </ul>
                            </div>
                            <div class="row border_row" v-else-if="this.errCode === '9992' && selectedCate.agnInfoYn === 'Y'">
                                <p class="border_row_title">안내전화</p>
                                <ul>
                                    <li>관리대리점의 연락처가 궁금하시다면 고객상담실(<a href="tel:1600-1234">1600-1234</a>)로 문의 해주세요.</li>
                                </ul>
                            </div>
                            <div class="row border_row" v-if="this.selectedSubCate === '45'">
                                <p class="border_row_title">기술지원 문의하기</p>
                                <RedLineButton :type="`inbound`" :text="`바로가기`" href="https://docs.kicc.co.kr/docs/support/informations/" />
                            </div>
                            <div class="row border_row" v-else-if="this.selectedSubCate === '46'">
                                <p class="border_row_title">계약 진행 조회</p>
                                <RedLineButton
                                    :type="`inbound`"
                                    :text="`바로가기`"
                                    href="https://www.easypay.co.kr/application/ApplyProgressAction.do"
                                />
                            </div>
                            <div class="row border_row" v-else-if="this.selectedSubCate === '47'">
                                <p class="border_row_title">결제 내역 조회</p>
                                <RedLineButton :type="`inbound`" :text="`바로가기`" href="https://www.easypay.co.kr/common/TradeCardAction.do" />
                            </div>
                            <div class="row border_row" v-else-if="this.selectedSubCate === '48'">
                                <p class="border_row_title">PG 신규 서비스 신청</p>
                                <RedLineButton
                                    :type="`inbound`"
                                    :text="`바로가기`"
                                    href="https://www.easypay.co.kr/application/ApplyIntroAction.do"
                                />
                            </div>

                            <div class="row">
                                <div class="input_group">
                                    <p>
                                        <span class="ess">*</span>
                                        문의사항으로 남기고 싶은 내용이 있으신가요?
                                    </p>
                                    <div class="input_row">
                                        <textarea name="" id="" placeholder="문의사항을 남겨주세요." ref="inquiry"></textarea>
                                    </div>
                                    <p class="sub_desc">
                                        ※ 저희 회사 업무시간은 오전 9시부터 오후 6시까지 입니다. 6시 이후 문의는 익 영업일 접수됩니다.
                                    </p>
                                </div>
                            </div>

                            <div class="row agree">
                                <h3>[필수] 개인정보 수집 및 이용동의</h3>
                                <div>
                                    <table>
                                        <colgroup>
                                            <col width="50%" />
                                            <col width="25%" />
                                            <col width="25%" />
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th>이용목적</th>
                                                <th>수집항목</th>
                                                <th>보유기간</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    유/무선 단말기 신청 및 서비스 이용 문의 부가서비스와 상품소개 서비스 이용에 따른 불만처리, 오류
                                                    해결 등 민원 처리 및 회신 시 사용
                                                </td>
                                                <td>
                                                    [필수항목]<br />
                                                    고객명, 휴대폰번호, 이메일<br />
                                                    [선택항목]<br />
                                                    사업자번호, 가맹점명<br />
                                                </td>
                                                <td>문의일로부터 1년</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="agree_bottom">
                                    <div class="input_group">
                                        <p>
                                            위 개인 정보 수집 이용에 대한 동의를 거부할 권리가 있으나, 거부할 경우 본 서비스 이용에 제한을 받을 수
                                            있습니다.
                                        </p>
                                        <div class="input_row">
                                            <label for="check_agr">
                                                <input type="checkbox" name="" id="check_agr" v-model="agrCheck" />
                                                <span class="check_box"></span>
                                                <span>동의</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>

                        <div class="row button_wrap">
                            <button type="button" :disabled="!selectedCate || !agrCheck" @click="submitVOC">문의하기</button>
                        </div>
                    </form>
                </div>
            </div>
        </SubSection>
    </LayoutSub>
    <div class="overlarp" v-if="submitLoading">
        <LoadingWrap />
    </div>
</template>
<script>
import { getAgnInfo, vocCateList, vocInsert } from '@/api';
import LoadingWrap from '@/components/LoadingWrap.vue';
import RedLineButton from '@/components/RedLineButton.vue';
import SubSection from '@/components/SubSection.vue';
import LayoutSub from '@/layouts/LayoutSub.vue';

export default {
    components: {
        LayoutSub,
        SubSection,
        RedLineButton,
        LoadingWrap,
    },
    data() {
        return {
            vocTypeData: [
                { tid: 1, name: '사업장' },
                { tid: 3, name: '신규/제휴' },
            ],
            submitLoading: false,
            selectedSubCate: null,
            selectedVocType: null,
            selectedCate: null,
            cateList: [],
            subCateList: [],
            agnInfor: null,
            errCode: null,
            lastAgnBussno: '',
            agnInfoLoading: false,
            agrCheck: false,
        };
    },
    mounted() {
        this.selectedVocType = this.vocTypeData[0];
        this.getCateList();
    },
    methods: {
        outerLink(config) {
            window.open(config);
        },
        async getCateList() {
            let { data } = await vocCateList();
            data = data.filter((el) => el.cid !== 9);
            data = this.renameVocCategories(data);
            this.cateList = data;
        },
        renameVocCategories(data) {
            return data.map((cate) => ({
                ...cate,
                list: cate.list?.map((subCate) => ({
                    ...subCate,
                    name: subCate.name === '인터넷사용처문의' ? '결제내역조회' : subCate.name,
                })),
            }));
        },
        changeVocType(voc) {
            this.selectedVocType = voc;
        },
        changeCate(cate) {
            this.selectedCate = cate;
            this.subCateList = cate.list;
            this.selectedSubCate = null;

            if (this.$refs.inquiry?.value) this.$refs.inquiry.value = null;
            if (this.selectedSubCate) this.selectedSubCate = null;

            if (this.shouldFetchAgnInfo(cate)) {
                this.fetchAgnInfo();
            } else {
                this.agnInfor = null;
                this.errCode = null;
            }
        },
        shouldFetchAgnInfo(cate = this.selectedCate) {
            return cate?.agnInfoYn === 'Y' && cate.name !== '이지페이';
        },
        handleBussnoInput(e) {
            e.target.value = e.target.value.replace(/\D/g, '');
            this.agnInfor = null;
            this.errCode = null;
            this.lastAgnBussno = '';

            if (e.target.value.length === 10 && (!this.selectedCate || this.shouldFetchAgnInfo())) {
                this.fetchAgnInfo();
            }
        },
        async fetchAgnInfo() {
            const { bussno, shopName, name, email1, email2, phone, smsYn } = this.$refs;
            const bussnoValue = bussno?.value || '';

            if (!/^\d{10}$/.test(bussnoValue) || this.agnInfoLoading || this.lastAgnBussno === bussnoValue) return;

            this.agnInfoLoading = true;
            this.lastAgnBussno = bussnoValue;

            try {
                const { data } = await getAgnInfo({
                    bussno: bussnoValue,
                    vocUserInfo: {
                        businessNo: bussnoValue,
                        merchantName: shopName?.value || '',
                        customerName: name?.value || '',
                        email: email1?.value && email2?.value ? `${email1.value}@${email2.value}` : '',
                        phoneNumber: phone?.value || '',
                        smsAgree: smsYn?.checked ? 'Y' : 'N',
                    },
                });

                this.errCode = data.resultCode;
                this.agnInfor = data.resultCode === '0000' ? data : null;
                if (data.resultCode === '4444') this.errCode = '9992';
            } catch (err) {
                this.agnInfor = null;
                this.errCode = '9992';
            } finally {
                this.agnInfoLoading = false;
            }
        },
        selectedCid(e) {
            if (e.target.checked) {
                this.selectedSubCate = e.target.value;
            }
        },
        addHyphenToPhoneNumber(phoneNumber) {
            const length = phoneNumber.length;

            if (length >= 9) {
                let numbers = phoneNumber.replace(/[^0-9]/g, '').replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`);
                return numbers;
            }

            if (length === 8) {
                let numbers = phoneNumber.replace(/[^0-9]/g, '').replace(/^(\d{4})(\d{4})$/, `$1-$2`);
                return numbers;
            }
        },
        checkValidation(domRef, regConfig) {
            const name = domRef.closest('.input_group').querySelector('p').textContent.replace('* ', '').trim();

            if (domRef?.value === '') {
                alert(`${name}을(를) 입력해주세요.`);
                domRef.focus();
                return false;
            }

            if (regConfig?.regEXP) {
                if (!regConfig.regEXP.test(domRef?.value)) {
                    alert(regConfig.errMsg);
                    domRef.focus();
                    return false;
                }
            }

            return true;
        },

        async submitVOC() {
            // 정규식 표현
            const { bussno, shopName, name, email1, email2, phone } = this.$refs;

            const regConfig = {
                businessNumber: {
                    regEXP: /^\d{10}$/,
                    errMsg: "사업자번호는 '-'를 제외한 숫자 10자리로 입력해주세요.",
                },
                userName: {
                    regEXP: /^[가-힣a-zA-Z]{2,}$/,
                    errMsg: '고객명은 한글 또는 영문 2자 이상으로 입력해주세요.',
                },
                email1: {
                    regEXP: /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*$/,
                    errMsg: '이메일을 확인해주세요.',
                },
                email2: {
                    regEXP: /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-z]{2,}$/,
                    errMsg: '이메일을 확인해주세요.',
                },
                phoneNum: {
                    regEXP: /^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/,
                    errMsg: '정확한 휴대폰 번호를 입력해주세요.',
                },
            };

            if (!this.checkValidation(bussno, regConfig.businessNumber)) return;
            if (!this.checkValidation(shopName)) return;
            if (!this.checkValidation(name, regConfig.userName)) return;
            if (!this.checkValidation(email1, regConfig.email1)) return;
            if (!this.checkValidation(email2, regConfig.email2)) return;
            if (!this.checkValidation(phone, regConfig.phoneNum)) return;
            if (this.selectedSubCate === null) return alert('문의사항을 체크해주세요.');
            if (this.$refs.inquiry?.value === '') return alert('문의사항을 남겨주세요.');

            const formData = new FormData();
            formData.append(
                'voc',
                JSON.stringify({
                    name: this.$refs.name?.value,
                    hpNo: this.$refs.phone?.value,
                    icid: this.selectedSubCate,
                    email: `${this.$refs.email1?.value}@${this.$refs.email2?.value}`,
                    inquiry: this.$refs.inquiry?.value,
                    shopGubun: this.selectedVocType.name,
                    bussNo: this.$refs.bussno?.value,
                    shopNm: this.$refs.shopName?.value,
                    smsYn: this.$refs.smsYn.checked ? 'Y' : 'N',
                })
            );

            if (this.submitLoading) return;
            this.submitLoading = true;

            try {
                await vocInsert(formData);

                // 입력 필드 초기화
                this.$refs.bussno.value = '';
                this.$refs.shopName.value = '';
                this.$refs.name.valueㅈ = '';
                this.$refs.email1.value = '';
                this.$refs.email2.value = '';
                this.$refs.phone.value = '';
                this.$refs.inquiry.value = '';
                this.$refs.smsYn.checked = false;
                this.selectedSubCate = null;
                this.agrCheck = false;
                this.selectedCate = null;
                alert('상담접수가 완료 되었습니다.');
                this.submitLoading = false;
            } catch (error) {
                alert('상담접수가 완료 되지 않았습니다.');
                this.submitLoading = false;
            }
        },
    },
};
</script>

<style scoped lang="scss">
.overlarp {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
}
</style>
